"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const icons_1 = require("@ant-design/icons");
const ServicesWrapper_1 = __importDefault(require("../servicesWrapper/ServicesWrapper"));
const NewService_1 = __importDefault(require("../newService/NewService"));
const ServiceCard_1 = __importDefault(require("../serviceCard/ServiceCard"));
require("./Maintenance.scss");
const RoutesPaths_1 = require("../../../../routes/RoutesPaths");
const Maintenance = () => {
    (0, react_1.useEffect)(() => {
        document.title = `360 Suítes - Manutenção & Solicitações`;
    }, []);
    return (react_1.default.createElement("div", { className: "Maintenance" },
        react_1.default.createElement(ServicesWrapper_1.default, { descriptionTitle: "Manuten\u00E7\u00E3o e Solicita\u00E7\u00F5es", descriptionText: react_1.default.createElement(react_1.default.Fragment, null,
                "Temos alguns servi\u00E7os dispon\u00EDveis em nossas acomoda\u00E7\u00F5es. Para criar uma solicita\u00E7\u00E3o clique no bot\u00E3o",
                react_1.default.createElement("b", null, " Novo pedido"),
                ".") },
            react_1.default.createElement("div", { className: "cards-container" },
                react_1.default.createElement(NewService_1.default, { icon: react_1.default.createElement(icons_1.PlusCircleOutlined, null), text: react_1.default.createElement("div", { className: "service-name" }, "Novo pedido") }),
                react_1.default.createElement(ServiceCard_1.default, { icon: react_1.default.createElement(icons_1.FileTextOutlined, null), text: react_1.default.createElement("div", { className: "service-name" }, "Meus pedidos"), to: RoutesPaths_1.routesPaths.myAccountRequests })))));
};
exports.default = Maintenance;
